import React, { memo, useState } from 'react';

import { discountTypes } from 'lib/constants/constants';

import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';
import { MAX_PERCENT_VALUE } from 'components/shared/CurrencyInput/lib/constants';

const DiscountCellEditor = memo((params) => {
  const { value, onValueChange, disabled, maxValue } = params || {};
  const [inputValue, setInputValue] = useState(value?.amount_cents ?? 0);
  const [inputUnit, setInputUnit] = useState(value?.type ?? discountTypes?.[0]?.value);

  const handleChange = (next) => {
    setInputValue(next);
    onValueChange?.({ ...value, amount_cents: next, type: inputUnit, discount_type: 'amount' });
  };
  const handleUnitChange = (unit) => {
    setInputUnit(unit);
    onValueChange?.({ ...value, amount_cents: inputValue, type: unit, discount_type: 'unit' });
  };

  return (
    <div tabIndex={1}>
      <CurrencyInput
        units={discountTypes}
        currentUnit={inputUnit}
        maxValue={inputUnit === 'percent' ? MAX_PERCENT_VALUE : maxValue}
        onUnitChange={handleUnitChange}
        optionPosition="top"
        variant="secondary"
        wrapperClassName="h-[38px] !rounded-none !p-0"
        hideBorder
        value={inputUnit === 'percent' ? value?.percentage : value?.amount_cents}
        onValueChange={handleChange}
        disabled={disabled}
      />
    </div>
  );
});

DiscountCellEditor.displayName = 'DiscountCellEditor';

export default DiscountCellEditor;
